/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { OrganisationPeekPathParams, OrganisationPeekResponse } from '../types/OrganisationPeek'

/**
 * GET /organisations/:organisation/peek
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::peek
 */
export async function organisationPeek(
	organisation: OrganisationPeekPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationPeekResponse>> {
	return axiosInstance.get(`/organisations/${organisation}/peek`, config)
}
